
import React from 'react'
import { connect } from 'react-redux'
import { compose } from 'recompose'
import { Button, Modal } from 'semantic-ui-react'
import { getHasError, getError } from '../selectors'
import { setError } from '../actions'


class ErrorMessageDialog extends React.Component {
	state = { open: this.props.hasError }

	close = () => {
		this.setState({ open: false })
		this.props.clearError()
	}

	componentWillReceiveProps(nextProp) {
		this.setState({ open: nextProp.hasError })
	}

	render() {
		return (
			<Modal open={this.state.open} onClose={this.close}>
				<Modal.Header><h3>System Message</h3></Modal.Header>
				<Modal.Content>
					{
						this.props.hasError
							&& this.props.error
							&& this.props.error.code !== undefined
							&& this.props.error.message !== undefined
							? <Modal.Description>
								<div>
									<h3 className='view-display'>Error Code : </h3 >
									<h3 className='view-display view-font-value'>{this.props.error.code}</h3>
								</div>
								<div>
									<h3 className='view-display'>Error Message : </h3>
									<h3 className='view-display view-font-value'>{this.props.error.message}</h3>
								</div>
							</Modal.Description>
							: <Modal.Description>
								<h3 className='view-display view-font-value'>Something went wrong !</h3>
							</Modal.Description>
					}
				</Modal.Content>
				<Modal.Actions>
					<Button
						className="buttonSubmit"
						onClick={this.close}>Ok</Button>
				</Modal.Actions>
			</Modal>
		)
	}
}

export default compose(
	connect(
		(state, props) => ({
			hasError: getHasError(state),
			error: getError(state),
		}),
		(dispatch) => ({
			clearError() {
				dispatch(setError(false))
			},
		})
	)
)(ErrorMessageDialog)


// WEBPACK FOOTER //
// ./src/features/ui/components/ErrorMessageDialog.js